import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getSearchShotclasses = (
  IsDistributed,
  IsPartOfProgram,
  SearchText,
  Status
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_SEARCH_SHOTCLASSES(
      IsDistributed,
      IsPartOfProgram,
      SearchText,
      Status
    ),
    "",
    cancelToken
  );
};

export default getSearchShotclasses;
